<template>
  <div class="tooltip_container">
    <span class="icon-info"></span>
    <div class="tooltip_box">
      <span v-html="TooltipText"></span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Tooltip",

    props: {
      TooltipText: String
    },

    data() {
      return {
        loaded: true,
      }
    }
  };

</script>

<style scoped lang="scss">
  .tooltip_container {
    cursor: pointer;

    .tooltip_box {
      position: absolute;
      display: none;
      background: #333333;
      color: white;
      padding: 15px;
      width: 150px;
      transform: translatex(45px);
      top: -10px;
      z-index: 2;

      &:before {
        content: '';
        position: absolute;
        right: 100%;
        border: 10px solid transparent;
        border-bottom-color: #333333;
        transform: rotatez(-90deg);
      }
    }

    &:hover {
      .tooltip_box {
        display: block;
      }
    }
  }
</style>